import * as component from "./component/index.js";
import { default as coreTokens } from "./core.js";
import { default as semanticTokens } from "./semantic.js";
const core = coreTokens.core;
const semantic = semanticTokens.semantic;
export const themeTokens = {
    core,
    semantic,
    component,
};
export { core, semantic, component };
